import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { toast } from "react-toastify";
import { RequestResults } from "../../common/RequestStatus";
import { Carrier } from "../../../types/CarrierTypes";
import { fetchCarrier } from "./carrierAsyncThunk";

interface CarrierState {
  data: Carrier[];
  status: RequestResults;
  loading: boolean;
  error: string | null;
}

const initialState: CarrierState = {
  data: [],
  status: RequestResults.idle,
  loading: false,
  error: null,
};

// Carrier Slice
const carrierSlice = createSlice({
  name: "carrier",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCarrier.pending, (state) => {
        state.status = RequestResults.pending;
        state.error = null;
      })
      .addCase(fetchCarrier.fulfilled, (state, action: PayloadAction<Carrier[]>) => {
        state.status = RequestResults.success;
        state.data = action.payload;
      })
      .addCase(fetchCarrier.rejected, (state, action) => {
        state.status = RequestResults.failed;
        toast.error(action.payload || "Failed to fetch carrier");
        state.error = action.payload || "Failed to fetch carrier";
      });
  },
});

export const selectCarrier = (state: RootState) => state.carrier;

export default carrierSlice.reducer;
